import { BlogCard } from './types';

export const ObagiHealthBlogCards: BlogCard[] = [
  {
    title: {
      content:
        '### Free Obagi Medical Skincare Day at Battersea Power Station: Drop In, Learn, and Leave With a Free Treatment',
      styles: {
        h3: 'font-Mulish font-bold text-royal-875 my-3 text-base md:text-lg leading-tight line-clamp-2',
      },

      topicsStyles: {
        h3: 'text-theme-primary text-3xl md:text-4xl my-4 md:my-6 p-2 font-black ',
      },
    },
    description: {
      content:
        'Free skincare education day with Obagi Medical at Battersea Power Station on Saturday 25 July. No booking needed',
      styles: {
        p: 'text-sm md:text-base text-text-default font-medium leading-relaxed mb-3',
      },
    },
    imageUrl: 'obagi-medical-blog.webp',
    bannerUrl: 'obagi-medical-blog-cover.webp',
    slug: 'lips-obagi-medical-skincare-day-battersea',
    contentType: 'article',
    tableOfContents: {
      heading: {
        content: '### TABLE OF CONTENTS:',
        styles: {
          h3: 'font-Mulish font-bold text-royal-875 mb-3 text-lg md:text-xl',
        },
      },
      content: [
        {
          text: 'What is happening on Saturday 25 July?',
          id: 'what-is-happening-on-saturday-25-july',
        },
        {
          text: 'What brands and treatments will be there?',
          id: 'what-brands-and-treatments-will-be-there',
        },
        {
          text: 'What are the offers on the day?',
          id: 'what-are-the-offers-on-the-day',
        },
        {
          text: 'How to find us at Battersea Power Station',
          id: 'how-to-find-us',
        },
      ],
      styles: {
        p: 'text-lg text-teal-500 underline leading-snug text-left cursor-pointer font-semibold',
      },
    },
    topics: {
      title: {
        content: '#### TOPICS:',
        styles: {
          h4: 'text-theme-primary font-extrabold p-2',
        },
      },
      topics: [
        'Obagi Medical London',
        'Aesthetics Consultation',
        'Skincare Event London',
      ],
      styles: {
        p: 'p-2 bg-info-500-opac-10 text-teal-450 bg-info-500-soft',
      },
    },
    speciality: 'Aesthetics',
    date: {
      content: '20, July 2026',
      iconUrl: '/images/blogs/calendar.svg',
      styles: {
        p: 'text-gray-500 text-xs',
      },
    },
    author: {
      content: 'LIPS Healthcare Marketing Team',
      styles: {
        p: 'text-indigo-650 font-bold text-xs',
        h3: 'text-theme-primary font-black text-2xl md:text-4xl',
      },
    },
    content: {
      content:
        '### Free skincare day with Obagi Medical at Battersea Power Station: what is on and what you get\n\nOn Saturday 25 July, LIPS Healthcare and Obagi Medical are hosting a free skincare education day at Turbine Hall B, Battersea Power Station. The event runs from 10:00am to 4:30pm and is completely free to attend. No booking needed. Drop in for ten minutes or spend the whole afternoon exploring each station. This article covers everything happening on the day, the offer available if you book a consultation, and how to find us.\n\n<span id=\'what-is-happening-on-saturday-25-july\'></span>\n\n### What is happening on Saturday 25 July?\n\nLIPS Healthcare and Obagi Medical are hosting a free skincare education day at Battersea Power Station on Saturday 25 July 2026, from 10:00am to 4:30pm\n\nIt is a drop in event. No registration. No fixed sessions. Arrive when it suits you, explore the stations at your own pace, and speak to specialists throughout the day. Whether you are curious about your skin, interested in a treatment, or want to learn more about medical grade skincare, this is a free, no pressure way to do exactly that.\n\n<strong><a href="https://forms.office.com/Pages/ResponsePage.aspx?id=U-XoRADADkq2BDU_7ZrCEHTk4F20XcpNjx3-JTMYA4BUOERHNExYVFg3RDNZWkpTWkc2UjVXQjFXRi4u" target="_blank" rel="noopener noreferrer">Join us on Saturday 25 July at LIPS Healthcare</a></strong>\n\n<div align="center">\n\n![Free skincare day at Battersea Power Station](obagi-medical-second-image.webp "1920x400")</div>\n\n<span id=\'what-is-happening-on-sunday-25-july\'></span>\n\n### What brands and treatments will be there?\n\nAlongside Obagi Medical, the day includes stations from Medik8, Jane Iredale, Epicutis, and Alastin. Each brand covers a different area of skincare, giving you a broad view of what medical-grade products and treatments can offer in a single afternoon.\n\nLive demonstrations run throughout the day. Jane Iredale will be offering colour matching so you can see how their range works for your skin tone in real time. LIPS Healthcare specialists will be at each station to answer questions and help you understand which products or treatments suit your skin and your goals.\n\n<span id=\'signs-allergy-test\'></span>\n\n### What are the offers on the day?\n\n<em>For everyone:</em >\n\n15 percent off retail purchases. Spend £200 or more in pharmacy or aesthetics and receive a complimentary Obagi Blue Peel Radiance treatment.\n\n<em>For Battersea Power Station residents and employees:</em >\n\n20 percent off retail purchases. Spend £200 or more on retail products, or book any aesthetics treatment, and receive a complimentary Obagi Blue Peel Radiance treatment. Check the Battersea Power Station app for your exclusive offer.\n\nObagi Blue Peel Radiance improves skin clarity and texture in a single session. 50 premium goody bags worth £200 available on a first come first served basis.\n\n<strong><a href="https://forms.office.com/Pages/ResponsePage.aspx?id=U-XoRADADkq2BDU_7ZrCEHTk4F20XcpNjx3-JTMYA4BUOERHNExYVFg3RDNZWkpTWkc2UjVXQjFXRi4u" target="_blank" rel="noopener noreferrer">Join us on Saturday 25 July at LIPS Healthcare</a></strong>\n\n\<div align="center">\n\n![Free skincare day at Battersea Power Station](obagi-medical-first-image.webp "1920x400")</div><span id=\'what-happens-paediatric-allergy\'></span>\n\n### How to find us at Battersea Power Station\n\n[LIPS Healthcare](/aesthetics-clinic#booking-calendar-widget), is at 1st Floor, Turbine Hall B, Battersea Power Station, London. The Northern line stops directly at Battersea Power Station station. Overground services run from Victoria and Clapham Junction. Multiple bus routes connect from Chelsea, Clapham, Vauxhall, Pimlico, and Wandsworth. Parking is available at Battersea Power Station if you are travelling by car.\n\nWe look forward to seeing you on the day.',

      styles: {
        h3: 'text-lg md:text-xl font-bold text-theme-primary mb-4',
        p: 'text-sm md:text-base text-text-default font-medium leading-relaxed mb-3',
        a: 'font-semibold text-text-action ',
        em: 'not-italic font-bold',
        strong:
          'inline-block bg-theme-primary hover:bg-white border border-theme-primary text-white px-6 py-3 rounded-lg font-bold no-underline cursor-pointer my-4 text-center [&_a]:text-white [&_a]:no-underline [&_a]:font-bold hover:[&_a]:text-theme-primary',
      },
    },
    faq: {
      heading: {
        content: '#### Frequently asked questions (FAQS)',
        styles: {
          h4: 'text-xl md:text-2xl font-bold text-theme-primary mb-6',
        },
      },
      items: [
        {
          question: {
            content:
              'Is the skincare day at Battersea Power Station free to attend?',
          },
          answer: {
            content:
              'Yes. The LIPS Healthcare and Obagi Medical skincare education day on Saturday 25 July is completely free to attend. No ticket, registration, or booking is required to drop in.',
          },
        },
        {
          question: { content: 'Do I need to book in advance to attend?' },
          answer: {
            content:
              'No. The event is drop-in. Arrive any time at Turbine Hall B, Battersea Power Station, and explore the stations at your own pace. No fixed sessions and no commitment required.',
          },
        },
        {
          question: {
            content: 'What is the offer for general visitors on the day?',
          },
          answer: {
            content:
              'General visitors receive 15 percent off retail product purchases. Spend £200 or more in pharmacy or aesthetics and receive a complimentary Obagi Blue Peel Radiance treatment. Fifty premium goody bags worth £200 are also available on a first come first served basis.',
          },
        },
        {
          question: {
            content:
              'Is there a special offer for Battersea Power Station residents and employees?',
          },
          answer: {
            content: `Yes. Battersea Power Station residents and employees receive 20 percent off retail product purchases. Spend £200 or more on retail products, or book any aesthetics treatment, and receive a complimentary Obagi Blue Peel Radiance treatment. Check the Battersea Power Station app for your exclusive offer before you arrive.`,
          },
        },
        {
          question: {
            content: 'What is Obagi Blue Peel Radiance?',
          },
          answer: {
            content:
              "Obagi Blue Peel Radiance is a skin resurfacing treatment available from Obagi Medical that improves skin clarity and texture in a single session. It is one of Obagi Medical's most popular in-clinic treatments and is available as a complimentary treatment with qualifying purchases or bookings at the LIPS Healthcare event on 25 July.",
          },
        },
      ],
    },
  },
];
